(() => {
  let pending = false;
  let bestsellers;
  const root = window.Shopify?.routes?.root || '/';
  async function fillFallback(block) {
    if (block.querySelector('.fy-offer') || block.dataset.loading) return;
    block.dataset.loading = 'true';
    try {
      bestsellers ||= fetch(`${root}collections/all?sort_by=best-selling&section_id=fellyra-cart-bestsellers`).then(r => { if (!r.ok) throw Error(); return r.text(); }).catch(e => { bestsellers = null; throw e; });
      const html = await bestsellers;
      if (!block.isConnected) return;
      const ids = JSON.parse(block.dataset.fyPresent).map(String);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const candidate = [...doc.querySelectorAll('.fy-offer')].find(e => !ids.includes(e.dataset.fyProduct));
      if (candidate) block.querySelector('[data-fy-offer]').append(candidate);
    } catch (_) {} finally { delete block.dataset.loading; }
  }
  function refresh() { document.querySelectorAll('[data-fy-upsell]').forEach(fillFallback); }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-fy-add]');
    if (!button || pending) return;
    event.preventDefault();
    pending = true;
    button.disabled = true;
    const drawer = button.closest('cart-drawer');
    const error = drawer.querySelector('[data-fy-upsell-error]');
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled = true;
    try {
      const state = await fetch(`${root}cart.js`).then(r => { if (!r.ok) throw Error(); return r.json(); });
      if (state.items.some(item => String(item.product_id) === button.dataset.fyProductId)) { refresh(); return; }
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: button.dataset.fyAdd, quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw Error(result.description || 'Hinzufügen nicht möglich. Bitte versuche es erneut.');
      if (!result.sections?.['cart-drawer']) throw Error('Warenkorb wurde aktualisiert. Bitte lade die Seite neu.');
      drawer.classList.remove('is-empty');
      drawer.renderContents(result);
      refresh();
      requestAnimationFrame(() => drawer.querySelector('#CartDrawer-Checkout')?.focus());
    } catch (e) { if (error?.isConnected) error.textContent = e.message || 'Bitte versuche es erneut.'; }
    finally { pending = false; if (button.isConnected) button.disabled = false; const next = drawer.querySelector('#CartDrawer-Checkout'); if (next) next.disabled = false; }
  });
  const target = document.querySelector('cart-drawer');
  if (target) new MutationObserver(refresh).observe(target, { childList: true, subtree: true });
  refresh();
})();
